/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedUnlimitedInstallStepsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_UNLIMITED_INSTALL_STEPS_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierAdvancedUnlimitedInstallStepsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedUnlimitedInstallStepsEnabledSettingParser.decode(input).map(res => new TierAdvancedUnlimitedInstallStepsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedUnlimitedInstallStepsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedUnlimitedInstallStepsEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedUnlimitedInstallStepsEnabledSettingParser.schema();
    }
}
